export const SEO_REGIONS = [
    { code: 'gb', label: 'United Kingdom', hreflang: 'en-GB' },
    { code: 'us', label: 'United States', hreflang: 'en-US' },
    { code: 'fr', label: 'France', hreflang: 'en-FR' },
    { code: 'de', label: 'Germany', hreflang: 'en-DE' },
    { code: 'nl', label: 'Netherlands', hreflang: 'en-NL' },
    { code: 'it', label: 'Italy', hreflang: 'en-IT' },
] as const;

export const SITE_ORIGIN = 'https://kibu.family';

export const getRegionalHomePath = (region: string): string => `/${region.toLowerCase()}/`;

export const getRegionalProductPath = (region: string): string => (
    `/${region.toLowerCase()}/products/wired-headphones-1/`
);

export const toAbsoluteSiteUrl = (path: string): string => new URL(path, SITE_ORIGIN).href;
